var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lading-page-cover"},[_c('v-parallax',{class:{ 'dark': _vm.dark, 'default-height': !_vm.hasCustomHeight },attrs:{"src":_vm.src,"height":_vm.parallaxHeight}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }